"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotsForAuction = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var lots_for_auction_1 = require("../../../../../api/calls/lot/v3/lots_for_auction");
var manual_set_current_1 = require("../../../../../api/calls/lot/v3/manual_set_current");
var main_1 = require("../../../../../reducers/slices/main");
var lot_status_1 = require("../../common/lot_status");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var socket_1 = require("../../../../../socket");
var manual_lot_status_1 = require("../../../../../api/calls/lot/v3/manual_lot_status");
var update_lot_status_1 = require("../../../../../api/calls/lot/v3/update_lot_status");
var LotsForAuction = function (props) {
    var _a;
    var currentLot = props.currentLot;
    var dispatch = (0, react_redux_1.useDispatch)();
    var filterRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), filterValue = _b[0], setFilterValue = _b[1];
    var _c = (0, react_1.useState)(null), lots = _c[0], setLots = _c[1];
    var _d = (0, react_1.useState)(null), current = _d[0], setCurrent = _d[1];
    var _e = (0, react_1.useState)(null), statusChanged = _e[0], setStatusChanged = _e[1];
    var _f = (0, react_1.useState)(null), selectedFilter = _f[0], setSelectedFilter = _f[1];
    var _g = (0, react_1.useState)(null), editingLotId = _g[0], setEditingLotId = _g[1];
    var _h = (0, react_1.useState)(false), liftPriceEnabled = _h[0], setLiftPriceEnabled = _h[1];
    var _j = (0, react_1.useState)(""), liftPrice = _j[0], setLiftPrice = _j[1];
    var _k = (0, react_1.useState)(false), showModal = _k[0], setShowModal = _k[1];
    // const id = useParams();
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    //   console.log(lots?.[0]?.entity_id, "lots");
    (0, react_1.useEffect)(function () {
        if (mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id) {
            (0, lots_for_auction_1.lots_for_auction)({
                auction_entity_id: mainAuction.entity_id,
            }).then(function (response) {
                //         console.log("response", response);
                setLots(response.data.content);
            });
        }
    }, [mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.entity_id]);
    (0, react_1.useEffect)(function () {
        if (currentLot) {
            setCurrent(currentLot);
            // socket.emit("joinLotPipe", currentLot.lot_entity_id);
        }
    }, [currentLot]);
    (0, react_1.useEffect)(function () {
        if (statusChanged) {
            var lot_entity_id_1 = statusChanged.lot_entity_id, reserve_price_check = statusChanged.reserve_price_check, reserve_price = statusChanged.reserve_price, auction_entity_id = statusChanged.auction_entity_id, title = statusChanged.title, status_1 = statusChanged.status, type = statusChanged.type, highest_bid = statusChanged.highest_bid;
            var foundLot = lots.find(function (lot) { return lot.entity_id === lot_entity_id_1; });
            if (foundLot) {
                foundLot.status = status_1;
                if (reserve_price_check) {
                    foundLot.reserve_price = reserve_price;
                }
                setLots(__spreadArray([], lots, true));
            }
        }
    }, [statusChanged]);
    // useEffect(() => {
    //   if (!current && lots && lots.length > 0) {
    //     // Pick the first lot that matches your filter
    //     const firstFilteredLot = lots
    //       .filter((x) => {
    //         if (!filterValue) return true;
    //         return x.lot_number == filterValue;
    //       })
    //       .filter((x) => {
    //         if (!selectedFilter) return true;
    //         return x.status == selectedFilter;
    //       })[0];
    //     if (firstFilteredLot) {
    //       setCurrent(firstFilteredLot);
    //     }
    //   }
    // }, [lots, filterValue, selectedFilter, current]);
    // useEffect(() => {
    //   if (lots && lots.length > 0 && !current) {
    //     const firstLot = lots[0];
    //     // Call backend to make this lot the current one too:
    //     manual_set_current({
    //       auction_entity_id: mainAuction.entity_id,
    //       lot_entity_id: firstLot.entity_id,
    //     }).then((response) => {
    //       if (response.data.success) {
    //         setCurrent(firstLot);
    //       } else {
    //         dispatch(setMessageModal({
    //           title: "Error",
    //           messages: [response.data.message],
    //         }));
    //       }
    //     });
    //   }
    // }, [lots, current]);
    (0, react_1.useEffect)(function () {
        socket_1.socket.on("lotStatusForAuction", function (data) {
            setStatusChanged(data);
        });
        return function () {
            socket_1.socket.off("lotStatusForAuction");
        };
    }, []);
    (0, react_1.useEffect)(function () {
        socket_1.socket.on("lotStatus", function (data) {
            setStatusChanged(data);
        });
        return function () {
            socket_1.socket.off("lotStatus");
        };
    }, []);
    var handleReservePriceUpdate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, res, updatedLots, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!liftPrice || !editingLotId) {
                        //       console.error("Missing required fields");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    payload = {
                        lot_id: editingLotId,
                        other_details: {
                            reserve_price: Number(liftPrice),
                        },
                    };
                    return [4 /*yield*/, (0, update_lot_status_1.update_lot_status)(payload)];
                case 2:
                    res = _a.sent();
                    // Update local state
                    if (lots) {
                        updatedLots = lots.map(function (l) { return (l.entity_id === editingLotId ? __assign(__assign({}, l), { reserve_price: Number(liftPrice) }) : l); });
                        setLots(updatedLots);
                    }
                    setShowModal(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formatWithSpaces = function (value) {
        return value
            .toString()
            .replace(/\D/g, "") // remove non-digit characters
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };
    var unformat = function (value) {
        var raw = value.replace(/\s/g, "");
        var num = parseFloat(raw);
        return isNaN(num) ? null : num;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col border-bluer border-4 rounded-xl w-full h-[450px] overflow-hidden" },
        react_1.default.createElement("div", { className: "w-full flex items-center justyfy-center bg-[#458CF2] py-2.5" },
            react_1.default.createElement("div", { className: "w-2/6 px-2" },
                react_1.default.createElement("span", { className: "text-base font-medium text-white" }, "Lots")),
            react_1.default.createElement("div", { className: "w-3/6 px-2" },
                react_1.default.createElement("div", { className: "w-full flex items-center gap-x-1.5" },
                    react_1.default.createElement("div", { className: "w-auto" },
                        react_1.default.createElement(doshx_controls_web_1.PopoverControl, { content: react_1.default.createElement("div", { className: "" },
                                react_1.default.createElement("div", { className: "flex justify-between" },
                                    react_1.default.createElement("div", { className: "font-bold" }, "Filter by..."),
                                    react_1.default.createElement("div", { className: "cursor-pointer text-sm text-red-600", onClick: function () {
                                            setSelectedFilter(null);
                                        } }, "Clear filter")),
                                react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { selectedValue: selectedFilter, onChange: function (value) {
                                        setSelectedFilter(value);
                                    }, options: [
                                        { label: "Bidding Open", value: "Bidding Open" },
                                        { label: "Sold", value: "Sold" },
                                        { label: "Passed", value: "Passed" },
                                        { label: "Withdrawn", value: "Withdrawn" },
                                    ] })) },
                            react_1.default.createElement("div", { className: "flex bg-white p-2 rounded-md cursor-pointer" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAlignJustify })))),
                    react_1.default.createElement("div", { className: "w-auto" },
                        react_1.default.createElement("div", { className: "text-white text-sm font-bold" }, lots === null || lots === void 0 ? void 0 : lots.length),
                        react_1.default.createElement("div", { className: "text-white text-xs" }, "TOTAL LOTS")),
                    react_1.default.createElement("div", { className: "w-auto" },
                        react_1.default.createElement("div", { className: "flex gap-2 h-8 bg-white rounded-lg overflow-clip" },
                            react_1.default.createElement("div", { className: "flex items-center cursor-pointer pl-2 text-bluer", onClick: function () {
                                    filterRef === null || filterRef === void 0 ? void 0 : filterRef.current.focus();
                                } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHashtag })),
                            react_1.default.createElement("input", { ref: filterRef, type: "number", min: 1, max: lots === null || lots === void 0 ? void 0 : lots.length, className: "w-14 bg-inherit border-black outline-none text-lg font-bold", onChange: function (e) {
                                    setFilterValue(e.target.value);
                                } }))))),
            react_1.default.createElement("div", { className: "w-1/6 px-2" },
                react_1.default.createElement("span", { className: "text-base font-medium text-white" }, "Lift Reserve"))),
        react_1.default.createElement("div", { className: "w-full flex flex-col h-full overflow-y-auto" }, (_a = (lots !== null && lots !== void 0 ? lots : [])
            .filter(function (x) {
            if (!filterValue) {
                return true;
            }
            return x.lot_number == filterValue;
        })
            .filter(function (x) {
            if (!selectedFilter) {
                return true;
            }
            return x.status == selectedFilter;
        })) === null || _a === void 0 ? void 0 : _a.map(function (lot, index) {
            var isCurrentLot = (current === null || current === void 0 ? void 0 : current.lot_number) === lot.lot_number;
            return (react_1.default.createElement("div", { key: "lot-".concat(index), className: "w-full flex items-center justify-center py-2\n                  ".concat(!isCurrentLot && "hover:bg-gray-200", " transition group\n                  ").concat(isCurrentLot && "bg-green-300", "\n                ") },
                react_1.default.createElement("div", { className: "w-2/6 px-2" },
                    react_1.default.createElement("div", { className: "w-full flex items-center gap-x-1.5" },
                        react_1.default.createElement("div", { className: "w-auto" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHashtag, className: "text-sm" }),
                            react_1.default.createElement("span", { className: "font-bold text-lg" }, lot.lot_number)),
                        react_1.default.createElement("div", { className: "flex-1" },
                            react_1.default.createElement("div", { className: "flex-1 line-clamp-2 break-words" }, lot.title)))),
                react_1.default.createElement("div", { className: "w-3/6 px-2" },
                    react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-1.5" },
                        react_1.default.createElement("div", { className: "w-full flex items-center gap-x-2" },
                            react_1.default.createElement("div", { className: "flex w-auto items-center gap-x-1" },
                                react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Mark as bidding open", placement: "top" },
                                    react_1.default.createElement("div", { className: "bg-orange-500 flex items-center px-2 rounded-md font-bold text-sm text-white cursor-pointer", onClick: function () {
                                            //                               console.log("HERE");
                                            (0, manual_lot_status_1.manual_lot_status)({
                                                entity_id: lot.entity_id,
                                                status: "Bidding Open",
                                            }).then(function (response) {
                                                if (response.data.success) {
                                                    //
                                                }
                                                else {
                                                    dispatch((0, main_1.setMessageModal)({
                                                        title: "Error",
                                                        messages: [response.data.message],
                                                    }));
                                                }
                                            });
                                        } }, "O")),
                                react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Mark as sold", placement: "top" },
                                    react_1.default.createElement("div", { className: "bg-green-500 flex items-center px-2 rounded-md font-bold text-sm text-white cursor-pointer", onClick: function () {
                                            (0, manual_lot_status_1.manual_lot_status)({
                                                entity_id: lot.entity_id,
                                                status: "Sold",
                                            }).then(function (response) {
                                                if (response.data.success) {
                                                    //
                                                }
                                                else {
                                                    dispatch((0, main_1.setMessageModal)({
                                                        title: "Error",
                                                        messages: [response.data.message],
                                                    }));
                                                }
                                            });
                                        } }, "S")),
                                react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Mark as passed", placement: "top" },
                                    react_1.default.createElement("div", { className: "bg-bluish flex items-center px-2 rounded-md font-bold text-sm text-white cursor-pointer", onClick: function () {
                                            (0, manual_lot_status_1.manual_lot_status)({
                                                entity_id: lot.entity_id,
                                                status: "Passed",
                                            }).then(function (response) {
                                                if (response.data.success) {
                                                    //
                                                }
                                                else {
                                                    dispatch((0, main_1.setMessageModal)({
                                                        title: "Error",
                                                        messages: [response.data.message],
                                                    }));
                                                }
                                            });
                                        } }, "P")),
                                react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Mark as withdrawn", placement: "top" },
                                    react_1.default.createElement("div", { className: "bg-red-500 flex items-center px-1 rounded-md font-bold text-sm text-white cursor-pointer", onClick: function () {
                                            //                               console.log("HERE");
                                            (0, manual_lot_status_1.manual_lot_status)({
                                                entity_id: lot.entity_id,
                                                status: "Withdrawn",
                                            }).then(function (response) {
                                                if (response.data.success) {
                                                    //
                                                }
                                                else {
                                                    dispatch((0, main_1.setMessageModal)({
                                                        title: "Error",
                                                        messages: [response.data.message],
                                                    }));
                                                }
                                            });
                                        } }, "W"))),
                            react_1.default.createElement("div", { className: "w-auto" },
                                react_1.default.createElement(lot_status_1.LotStatus, { lot_status: lot.status })),
                            isCurrentLot ? (react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Currently active", placement: "top" },
                                react_1.default.createElement("div", { className: "h-6 bg-bluish flex items-center px-2 rounded-md font-bold text-md text-white cursor-pointer", onClick: function () {
                                        //
                                    } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faClock })))) : (lot.status == "Bidding Open" && (react_1.default.createElement(doshx_controls_web_1.TooltipControl, { label: "Jump to this lot", placement: "top" },
                                react_1.default.createElement("div", { className: "h-6 bg-orange-400 flex items-center px-2 rounded-md font-bold text-md text-white cursor-pointer", onClick: function () {
                                        (0, manual_set_current_1.manual_set_current)({
                                            auction_entity_id: mainAuction.entity_id,
                                            lot_entity_id: lot.entity_id,
                                        }).then(function (response) {
                                            if (response.data.success) {
                                                // setCurrent(lot); 
                                                //
                                            }
                                            else {
                                                dispatch((0, main_1.setMessageModal)({
                                                    title: "Error",
                                                    messages: [response.data.message],
                                                }));
                                            }
                                        });
                                    } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowRightArrowLeft })))))),
                        react_1.default.createElement("div", { className: "w-full flex justify-center" },
                            react_1.default.createElement("div", { className: "w-auto px-4 flex justify-center items-center rounded-[8px] bg-[#42B74A] h-[24px] text-white" },
                                react_1.default.createElement("span", null, (lot === null || lot === void 0 ? void 0 : lot.reserve_price) ? "RA ".concat(formatWithSpaces(lot.reserve_price)) : "No Reserve"))))),
                react_1.default.createElement("div", { className: "w-1/6 px-2 relative" },
                    react_1.default.createElement("div", { key: "lot-".concat(index), className: "flex items-center gap-4 py-2 px-2 " },
                        react_1.default.createElement(doshx_controls_web_1.SwitchControl, { label: "", 
                            // checked={lot?.reserve_price?true:false}
                            onChange: function (v) {
                                if (!v) {
                                    setLiftPriceEnabled(false);
                                    setLiftPrice("");
                                }
                                else {
                                    setLiftPriceEnabled(true);
                                    setEditingLotId(lot.entity_id);
                                    setShowModal(true); // Open modal
                                }
                            } })),
                    showModal && editingLotId === lot.entity_id && (react_1.default.createElement("div", { className: "absolute top-full right-0 mt-1 z-50 w-64 bg-white rounded-md shadow-lg border border-gray-200" },
                        react_1.default.createElement("div", { className: "p-3 flex flex-col gap-2" },
                            react_1.default.createElement("div", { className: "font-medium text-sm" }, "Set Reserve Price"),
                            react_1.default.createElement("input", { type: "text", value: formatWithSpaces(liftPrice || ""), onChange: function (e) {
                                    var formatted = e.target.value;
                                    var parsed = unformat(formatted);
                                    if (parsed !== null && parsed >= 0) {
                                        setLiftPrice(parsed);
                                    }
                                    else if (formatted === "") {
                                        setLiftPrice(""); // Allow clearing
                                    }
                                }, className: "border rounded px-2 py-1 text-sm", placeholder: "Enter amount" }),
                            react_1.default.createElement("div", { className: "flex justify-end gap-2" },
                                react_1.default.createElement("button", { className: "px-3 py-1 text-xs bg-gray-100 rounded hover:bg-gray-200", onClick: function () { return setShowModal(false); } }, "Cancel"),
                                react_1.default.createElement("button", { className: "px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600", onClick: handleReservePriceUpdate }, "Save"))))))));
        }))));
};
exports.LotsForAuction = LotsForAuction;
